const unauthorised = (error) => {
    return error.response && error.response.status === 401
}

export default unauthorised